export const assignmentRoutes = {
	assignmentsList: '/assignments/assignments-list',
	assignment: '/assignments/assignment/:assignmentId',
	assignmentEdit: '/assignments/assignment/:assignmentId/edit',
	assignmentAdd: '/assignments/add-assignment',
};
